import { Outlet } from "react-router-dom";
import css from "./content.module.css";

export const Content = (props) => {
  // const location = useLocation();
  let className = props.isMenuVisible ? css.container : css.noSidebar;

  const showMenu = () => {
    if (window.innerWidth <= 960) {
      props.setIsMenuVisible(false);
    } else {
      props.setIsMenuVisible(true);
    }
  };

  window.addEventListener("resize", showMenu);

  return (
    <>
      {/* <Breadcrumbs list={location.pathname} /> */}
      <div className={className}>
        {props.component}
        <Outlet />
      </div>
    </>
  );
};
